$(document).ready(function () { 
$("#country_selector").countrySelect({
				onlyCountries: ['gb', 'fr', 'es', 'pt', 'it', 'nl', 'de','tr'],
   				defaultCountry: "gb",
  preferredCountries: [],
  				responsiveDropdown: true
			});
  
  

  
  $( "#country_selector" ).change(function() {
		var cntcode = $('#country_selector_code').val();
    
    
    	$('.lang').hide();
    
    	$('.lang_'+cntcode).show();
    
});
  
  
  /*Account pages validations */
  /*Login form */
  jQuery("#customer_login").validate({
    errorElement: 'span',
    errorClass: 'input--error',
    rules: {
      "customer[password]": {
        required: true,
        minlength: 5
      },
      "customer[email]":{
        required: true,
        email: true,//add an email rule that will ensure the value entered is valid email id.
        maxlength: 255
      }
    },messages: {  
      "customer[email]": 'Enter a valid email include @ , "."'     
    },
    submitHandler: function(form) {
      form.submit();
    }
  });
  
  /*Recover Password form */
  jQuery("#recover_customer_password").validate({
    errorElement: 'span',
    errorClass: 'input--error',
    rules: {
      "email":{
        required: true,
        email: true,//add an email rule that will ensure the value entered is valid email id.
        maxlength: 255
      }
    },messages: {  
      "email": 'Enter a valid email include @ , "."'     
    },
    submitHandler: function(form) {
      form.submit();
    }
  });
  
  
  //Registration form 
  jQuery("#customer_registration").validate({
    errorElement: 'span',
    errorClass: 'input--error',
    rules: {
      "customer[first_name]": 'required',
      "customer[last_name]": 'required',
      "customer[email]": {
        required: true,
        email: true,//add an email rule that will ensure the value entered is valid email id.
        maxlength: 255,
      },
      checkTerms :'required',
      checkUse : 'required',
      "customer[password]": {
        required: true,
        minlength: 5
      },
      "customer[cpassword]": {
        required: true,
        minlength: 5,
        equalTo: "#password"
      }
    },
    messages: {
      "customer[first_name]": 'This field is required',
      "customer[last_name]": 'This field is required',
      "customer[email]": 'Enter a valid email include @ , "."',
      checkTerms: 'This  is required Accept the terms',
      checkUse : 'This field is required'
    },
    submitHandler: function(form) {
      form.submit();
    }
  });
  
  
  /*Contact Us form */
  jQuery("#contact_footer").validate({
    errorElement: 'span',
    errorClass: 'input--error',
    rules: {
      "contact[email]": {
        required: true,
        email: true,//add an email rule that will ensure the value entered is valid email id.
        maxlength: 255
      }
    },messages: {  
      "contact[email]": 'Enter a valid email include @ , "."'     
    },
    submitHandler: function(form) {
      form.submit();
    }
  });
  
  
  /** Customize Subscrib from functionallity */
  $('#ContactFooter .submit-btn').click(function(){
    //validate Email address 
    var email = $("#ContactFooter .custom-input input").val();
    
    if(!email || email == null || email == " " || email.length == 0) {
      $("#ContactFooter .input-error-message .site-footer__newsletter-error").text("Please enter email address");
      $("#ContactFooter").removeClass("success");
      $("#ContactFooter").addClass("something-wrong");
    }
    else {
     //validate email:
      if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email))
      {
        //$('#ContactFooter').submit();
        //Submit form by ajax
        var data = $("#ContactFooter").serialize();
        $.ajax({  
          type: "POST",  
          url: "/contact",  
          data: data,
          success: function() {      
            $("#ContactFooter .form-message--success").removeClass("hide");
            
            $("#ContactFooter").addClass("success");
        	$("#ContactFooter").removeClass("something-wrong");
            
            
                //For footerEmail
     
      $.cookie('signupFooter', 'yes', { expires: 999}); 

            
          },
          error: function() {
            $("#ContactFooter .site-footer__newsletter-error").text("Erro while subscribing");
            console.log("ContactFooter error");
          }
        });
        return (true)
      }
      else {
        $("#ContactFooter .input-error-message .site-footer__newsletter-error").text("You have entered an invalid email address!");
        $("#ContactFooter").removeClass("success");
        $("#ContactFooter").addClass("something-wrong");
      }
    }
  });
  
  $("#ContactFooter .custom-input input").keyup(function(){
    if($(this).val() != ""){
    	$("#ContactFooter .input-error-message .site-footer__newsletter-error").text("");
    }
  });
  
    
  /** Customize Welcome Popup from functionallity */
  $('#WelcomePopupContact #subscribe-welcome').click(function(){
    //validate Email address 
    var email = $("#WelcomePopupContact .custom-input input").val();

    if(!email || email == null || email == " " || email.length == 0) {
      $("#WelcomePopupContact .input-error-message .site-footer__newsletter-error").text("Please enter email address");
      $("#WelcomePopupContact").removeClass("success");
      $("#WelcomePopupContact").addClass("something-wrong");
    }
    else {
      //validate email:
      if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email))
      {
        //$('#WelcomePopupContact').submit();
        //Submit Welcome popup by ajax
        var data = $("#WelcomePopupContact").serialize();
        $.ajax({  
          type: "POST",  
          url: "/contact",  
          data: data,
          success: function() { 
            
            $.cookie('visited', 'yes', { expires: 999});
            
            $("#WelcomePopupContact .form-message--success").removeClass("hide");
            
            $("#WelcomePopupContact").addClass("success");
        	$("#WelcomePopupContact").removeClass("something-wrong");
          },
          error: function() {
            $("#WelcomePopupContact .site-footer__newsletter-error").text("Error while subscribing");
            console.log("WelcomePopupContact error");
          }
        });
        return (true)
      }
      else {
        $("#WelcomePopupContact .input-error-message .site-footer__newsletter-error").text("You have entered an invalid email address!");
      	$("#WelcomePopupContact").removeClass("success");
        $("#WelcomePopupContact").addClass("something-wrong");
      }
    }
  });
  
  $("#WelcomePopupContact .custom-input input").keyup(function(){
    if($(this).val() != ""){
    	$("#WelcomePopupContact .input-error-message .site-footer__newsletter-error").text("");
    }
  }); 
  
    //For WelcomeModel
    var visited = null;
    if ($.cookie('visited') == null) {
      setTimeout(function() {
        $('#skincare-modal').modal("show");
      }, 8000);
      $.cookie('visited', 'yes', { expires: 30}); 
    }
  
  
  
  
    //For signupFooter
    var signupFooter = null;
    if ($.cookie('signupFooter') == 'yes') {
     
      $('.roc-signup-section').hide();
    }
});

$(document).on('Searchanise.ResultsUpdated', function(event, results) {
  setTimeout(function() {
	
    var cnt = $("#CartCount").text();
		cnt = cnt.replace(/[^0-9]/g, '');

	$("#CartCount").text("("+parseInt(cnt)+")");
  }, 500);
});


/*Custom Add to cart Button click */  
function renderCartForSearchanise() {
  setTimeout(function() {
    sellify.ucd.helpers.ajaxCart.load(true);
    sellify.ucd.helpers.ajaxCart.show();
  }, 300);
  
  setTimeout(function() {
    var cnt = $("#CartCount").text();
		cnt = cnt.replace(/[^0-9]/g, '');
    
    $("#CartCount").text("("+parseInt(cnt)+")");
  }, 1000);
}

function waitUntilDefined() {
  if (
    typeof Searchanise !== 'undefined' &&
    typeof Searchanise.$ !== 'undefined'
  ) {
    Searchanise.$(document).on('Searchanise.AddToCartSuccess', renderCartForSearchanise);
  } else {
    setTimeout(waitUntilDefined, 400);
  }
}

waitUntilDefined();

//=================================================================================================================
//For Quiz Section

$(document).ready(function(){
  
  var result1 = "retinol-correxion-line-smoothing-night-serum-capsules-10ct";
  var result2 = "multi-correxion-revive-glow-gel-cream";
  var result3 = "retinol-correxion-max-daily-hydration-fragrance-free-cream";
  var result4 = "derm-correxion-firming-serum-stick";
  var result5 = "derm-correxion-firming-serum-stick";
  var result6 = "retinol-correxion-line-smoothing-eye-cream";
  var result7 = "retinol-correxion-deep-wrinkle-rich-cream";
  var result8 = "multi-correxion-revive-glow-gel-cleanser";
  var result9 = "line-smoothing-daily-cleansing-pads";
  var result10 = "line-smoothing-daily-cleansing-pads";
  var result11 = "multi-correxion-revive-glow-gel-cleanser";
  var result12 = "line-smoothing-daily-cleansing-pads";
  var result13 = "hydration-moisturizer";
  var result14 = "soleil-protect-anti-wrinkle-smoothing-fluid-spf50-1";
  var result15 = "soleil-protect-anti-wrinkle-smoothing-fluid-spf50-1";
  var result16 = "soleil-protect-anti-wrinkle-smoothing-fluid-spf50-1";
  var result17 = "hydration-moisturizer";
  var result18 = "soleil-protect-anti-wrinkle-smoothing-fluid-spf50-1";
  var result19 = "soleil-protect-anti-brown-spot-unifying-fluid-spf-50";
  var result20 = "soleil-protect-anti-wrinkle-smoothing-fluid-spf50-1";
  var result21 = "keops-fresh-spray-deodorant";
  var result22 = "keops-dry-spray-deodorant";
  var result23 = "keops-roll-on-deodorant-sensitive-skin";
  var result24 = "keops-roll-on-deodorant-normal-skin";
  var result25 = "keops-stick-deodorant";
  var result26 = "retinol-correxion-max-daily-hydration-fragrance-free-cream";
  var result27 = "multi-correxion-revive-glow-daily-serum";
  var result28 = "multi-correxion-revive-glow-gel-cream";
  var result29 = "retinol-correxion-line-smoothing-night-serum-capsules";
  var result30 = "retinol-correxion-deep-wrinkle-night-cream-1";
  var result31 = "retinol-correxion-deep-wrinkle-rich-cream";
  var result32 = "retinol-correxion-line-smoothing-eye-cream";



  
  var quiz_data = 
      {
        "no_signs_of_aging": {
          "extreme_dryness": {
            "sensitive": {
              "dark_circles": {
                "products": [ 
                  result7
                ],
                "also_Suggest": [
                  result10
                ]
              },
              "lines_wrinkles": {
                "products": [
                  result7
                ],
                "also_Suggest": [
                  result10
                ]
              }
            },
            "nothing": {
              "dark_circles": {
                "products": [
                  result7 
                ],
                "also_Suggest": [
                  result10
                ]
              },
              "lines_wrinkles": {
                "products": [
                  result7
                ],
                "also_Suggest": [
                  result10
                ]
              }
            }
          },
          "fine_lines": {
            "sensitive": {
              "dark_circles": {
                "products": [
                  result26,
                  result3,
                  result29
                ],
                "also_Suggest": [
                  result32
                ]
              },
              "lines_wrinkles": {
                "products": [
                  result26,
                  result3,
                  result29
                ],
                "also_Suggest": [
                  result32
                ]
              }
            },
            "nothing": {
              "dark_circles": {
                "products": [
                  result26,
                  result3,
                  result29
                ],
                "also_Suggest": [
                  result32
                ]
              },
              "lines_wrinkles": {
                "products": [
                  result26,
                  result3,
                  result29
                ],
                "also_Suggest": [
                  result32
                ]
              }
            }
          },
          "deep_wrinkles": {},
          "loose_sagging_skin": {},
          "uneven_skin_tone": {
            "sensitive": {
            "dark_circles": {
                "products": [
                  result27,
                  result19,
                  result2
                ],
                "also_Suggest": [
                  result8
                ]
              },
              "lines_wrinkles": {
                "products": [
                  result27,
                  result19,
                  result2
                ],
                "also_Suggest": [
                  result8
                ]
              }
            },
            "nothing": {
              "dark_circles": {
                "products": [
                  result27,
                  result19,
                  result2
                ],
                "also_Suggest": [
                  result8
                ]
              },
              "lines_wrinkles": {
                "products": [
                  result27,
                  result19,
                  result2
                ],
                "also_Suggest": [
                  result8
                ]
              }
            }
          },
          "dark_spots_discoloration": {}
        },
        "some_signs_of_aging": {
          "extreme_dryness": {
            "sensitive": {
              "dark_circles": {
                "products": [
                  result18,
                  result7
                ],
                "also_Suggest": [
                  result10
                ]
              },
              "lines_wrinkles": {
                 "products": [
                  result18,
                  result7
                ],
                "also_Suggest": [
                  result10
                ]
              }
            },
            "nothing": {
              "dark_circles": {
                 "products": [
                  result18,
                  result7
                ],
                "also_Suggest": [
                  result10
                ]
              },
              "lines_wrinkles": {
                 "products": [
                  result18,
                  result7
                ],
                "also_Suggest": [
                  result10
                ]
              }
            }
          },
          "fine_lines": {
            "sensitive": {
              "dark_circles": {
                "products": [
                  result26,
                  result3,
                  result29
                ],
                "also_Suggest": [
                  result32
                ]
              },
              "lines_wrinkles": {
                "products": [
                  result26,
                  result3,
                  result29
                ],
                "also_Suggest": [
                  result32
                ]
              }
            },
            "nothing": {
              "dark_circles": {
                "products": [
                  result26,
                  result3,
                  result29
                ],
                "also_Suggest": [
                  result32
                ]
              },
              "lines_wrinkles": {
                "products": [
                  result26,
                  result3,
                  result29
                ],
                "also_Suggest": [
                  result32
                ]
              }
            }
          },
          "deep_wrinkles": {
            "sensitive": {
              "dark_circles": {
                "products": [
                  result26,
                  result31,
                  result30
                ],
                "also_Suggest": [
                  result6
                ]
              },
              "lines_wrinkles": {
                "products": [
                  result26,
                  result31,
                  result30
                ],
                "also_Suggest": [
                  result6
                ]
              }
            },
            "nothing": {
              "dark_circles": {
                "products": [
                  result26,
                  result31,
                  result30
                ],
                "also_Suggest": [
                  result6
                ]
              },
              "lines_wrinkles": {
                "products": [
                  result26,
                  result31,
                  result30
                ],
                "also_Suggest": [
                  result6
                ]
              }
            }
          },
          "loose_sagging_skin": {
            "sensitive": {
              "dark_circles": {
                "products": [
                  result4,
                  result5
                ],
                "also_Suggest": [
                  result6
                ]
              },
              "lines_wrinkles": {
                "products": [
                  result4,
                  result5
                ],
                "also_Suggest": [
                  result6
                ]
              }
            },
            "nothing": {
              "dark_circles": {
                "products": [
                  result4,
                  result5
                ],
                "also_Suggest": [
                  result6
                ]
              },
              "lines_wrinkles": {
                "products": [
                  result4,
                  result5
                ],
                "also_Suggest": [
                  result6
                ]
              }
            }
          },
          "uneven_skin_tone": {
            "sensitive": {
              "dark_circles": {
                "products": [
                  result27,
                  result19,
                  result2
                ],
                "also_Suggest": [
                  result8
                ]
              },
              "lines_wrinkles": {
                "products": [
                  result27,
                  result19,
                  result2
                ],
                "also_Suggest": [
                  result8
                ]
              }
            },
            "nothing": {
              "dark_circles": {
                "products": [
                  result27,
                  result19,
                  result2
                ],
                "also_Suggest": [
                  result8
                ]
              },
              "lines_wrinkles": {
                "products": [
                  result27,
                  result19,
                  result2
                ],
                "also_Suggest": [
                  result8
                ]
              }
            }
          },
          "dark_spots_discoloration": {
            "sensitive": {
              "dark_circles": {
                "products": [
                  result27,
                  result19,
                  result2
                ],
                "also_Suggest": [
                  result32
                ]
              },
              "lines_wrinkles": {
                "products": [
                  result27,
                  result19,
                  result2
                ],
                "also_Suggest": [
                  result32
                ]
              }
            },
            "nothing": {
              "dark_circles": {
                "products": [
                  result27,
                  result19,
                  result2
                ],
                "also_Suggest": [
                  result32
                ]
              },
              "lines_wrinkles": {
                "products": [
                  result27,
                  result19,
                  result2
                ],
                "also_Suggest": [
                  result32
                ]
              }
            }
          }
        },
        "pronounced_signs_of_aging": {
          "extreme_dryness": {
            "sensitive": {
              "dark_circles": {
                "products": [
                  result31,
                  result7
                ],
                "also_Suggest": [
                  result10
                ]
              },
              "lines_wrinkles": {
                "products": [
                  result31,
                  result7
                ],
                "also_Suggest": [
                  result10
                ]
              }
            },
            "nothing": {
              "dark_circles": {
                "products": [
                  result31,
                  result7
                ],
                "also_Suggest": [
                  result10
                ]
              },
              "lines_wrinkles": {
                "products": [
                  result31,
                  result7
                ],
                "also_Suggest": [
                  result10
                ]
              }
            }
          },
          "fine_lines": {
            "sensitive": {
              "dark_circles": {
                "products": [
                  result26,
                  result31,
                  result7
                ],
                "also_Suggest": [
                  result29
                ]
              },
              "lines_wrinkles": {
                "products": [
                  result26,
                  result31,
                  result7
                ],
                "also_Suggest": [
                  result29
                ]
              }
            },
            "nothing": {
              "dark_circles": {
                "products": [
                  result26,
                  result31,
                  result7
                ],
                "also_Suggest": [
                  result29
                ]
              },
              "lines_wrinkles": {
                "products": [
                  result26,
                  result31,
                  result7
                ],
                "also_Suggest": [
                  result29
                ]
              }
            }
          },
          "deep_wrinkles": {
            "sensitive": {
              "dark_circles": {
                "products": [
                  result5,
                  result31,
                  result30
                ],
                "also_Suggest": [
                  result32
                ]
              },
              "lines_wrinkles": {
                "products": [
                  result5,
                  result31,
                  result30
                ],
                "also_Suggest": [
                  result32
                ]
              }
            },
            "nothing": {
              "dark_circles": {
                "products": [
                  result5,
                  result31,
                  result30
                ],
                "also_Suggest": [
                  result32
                ]
              },
              "lines_wrinkles": {
                "products": [
                  result5,
                  result31,
                  result30
                ],
                "also_Suggest": [
                  result32
                ]
              }
            }
          },
          "loose_sagging_skin": {
            "sensitive": {
              "dark_circles": {
                "products": [
                  result5,
                  result4,
                  result30
                ],
                "also_Suggest": [
                  result32
                ]
              },
              "lines_wrinkles": {
                "products": [
                  result5,
                  result4,
                  result30
                ],
                "also_Suggest": [
                  result32
                ]
              }
            },
            "nothing": {
              "dark_circles": {
                "products": [
                  result5,
                  result4,
                  result30
                ],
                "also_Suggest": [
                  result32
                ]
              },
              "lines_wrinkles": {
                "products": [
                  result5,
                  result4,
                  result30
                ],
                "also_Suggest": [
                  result32
                ]
              }
            }
          },
          "uneven_skin_tone": {
            "sensitive": {
              "dark_circles": {
                "products": [
                  result27,
                  result19,
                  result2
                ],
                "also_Suggest": [
                  result8
                ]
              },
              "lines_wrinkles": {
                "products": [
                  result27,
                  result19,
                  result2
                ],
                "also_Suggest": [
                  result8
                ]
              }
            },
            "nothing": {
              "dark_circles": {
                "products": [
                  result27,
                  result19,
                  result2
                ],
                "also_Suggest": [
                  result8
                ]
              },
              "lines_wrinkles": {
                "products": [
                  result27,
                  result19,
                  result2
                ],
                "also_Suggest": [
                  result8
                ]
              }
            }
          },
          "dark_spots_discoloration": {
            "sensitive": {
              "dark_circles": {
                "products": [
                  result27,
                  result19,
                  result2
                ],
                "also_Suggest": [
                  result32
                ]
              },
              "lines_wrinkles": {
                "products": [
                  result27,
                  result19,
                  result2
                ],
                "also_Suggest": [
                  result32
                ]
              }
            },
            "nothing": {
              "dark_circles": {
                "products": [
                  result27,
                  result19,
                  result2
                ],
                "also_Suggest": [
                  result32
                ]
              },
              "lines_wrinkles": {
                "products": [
                  result27,
                  result19,
                  result2
                ],
                "also_Suggest": [
                  result32
                ]
              }
            }
          }
        }
      }

  
  $(".quize-section .roc-btn-black").on("click", function(){
    var result_array = [];
    
	var face_condition_c = $(".quize-section #face_condition").val();
    var skin_condition_c = $(".quize-section #skin_condition").val();
    var biggest_skin_concern_c = $(".quize-section #biggest_skin_concern").val();
    var eye_condition_c = $(".quize-section #eye_condition").val();
    var no_data = 0;
    
    if(skin_condition_c != "sensitive") {
    	skin_condition_c = "nothing";
    }
    
    for(var face_condition in quiz_data) {
      var face_condition_2 = quiz_data[face_condition];
      
      if(typeof face_condition_2 == "object") {
        for(var biggest_skin_concern in face_condition_2) {
          	var biggest_skin_concern_2 = face_condition_2[biggest_skin_concern];
          
          if(typeof biggest_skin_concern_2 == "object") {
            for(var skin_condition in biggest_skin_concern_2) {
               var skin_condition_2 = biggest_skin_concern_2[skin_condition];
              
              if (typeof skin_condition_2 == "object") {
                for(var eye_condition in skin_condition_2) { 
                	var eye_condition_2 = skin_condition_2[eye_condition];
                  
                    if(face_condition == face_condition_c && biggest_skin_concern == biggest_skin_concern_c 
                       && skin_condition == skin_condition_c && eye_condition == eye_condition_c) {
                      
                      for(var result in eye_condition_2) { 
                        result_array.push(eye_condition_2[result]);
                      }
                    }
                    else {
                      no_data = no_data + 1;
                    }
                }
              }  
            }
          }
        }
      }
    }
    var products = [], also_suggest = [];
    $(".quiz-customer-product").removeClass("hide");
    
   
    if(typeof ga === 'function'){
    
    //save into GOOGLE
      ga('send', 'event', 'QUIZ', 'click', 'Q1',$(".quize-section #face_condition").val());
      ga('send', 'event', 'QUIZ', 'click', 'Q2',$(".quize-section #my_age").val());
      ga('send', 'event', 'QUIZ', 'click', 'Q3',$(".quize-section #skin_condition").val());
      ga('send', 'event', 'QUIZ', 'click', 'Q4',$(".quize-section #biggest_skin_concern").val());
      ga('send', 'event', 'QUIZ', 'click', 'Q5',$(".quize-section #eye_condition").val());
      ga('send', 'event', 'QUIZ', 'click', 'Q6',$(".quize-section #have_use_retinol").val());
    
    }
    var answers=[$(".quize-section #face_condition").val(),
                 $(".quize-section #my_age").val(),
                 $(".quize-section #skin_condition").val(),
                 $(".quize-section #biggest_skin_concern").val(),
                 $(".quize-section #eye_condition").val(),
                 $(".quize-section #have_use_retinol").val()]
                 
    

    


    
     $.cookie('quiz', JSON.stringify(answers), { expires: 1}); 
    
    $('.quiz-customer-product').removeClass('hide');
    
    
    
    
//     //save into klaviyo
//       var _learnq = _learnq || [];
    
//     // Identifying a person and tracking special Klaviyo properties.
//   _learnq.push(['identify', {
//     '$email' : $('#email').val(),
// 		'Q1' : $(".quize-section #face_condition").val(),
//     'Q2' : $(".quize-section #my_age").val(),
//     'Q3' : $(".quize-section #skin_condition").val(),
//     'Q4' : $(".quize-section #biggest_skin_concern").val(),
//     'Q5' : $(".quize-section #eye_condition").val(),
//     'Q6' : $(".quize-section #have_use_retinol").val()
//   }]);
    
    
    //show message
    
    
    if($(".quize-section #have_use_retinol").val() == 'have'){
    	$('.retinoldetail').removeClass("hide");
        $('.noretinoldetail').addClass("hide");
    }else if($(".quize-section #have_use_retinol").val() == 'have-not'){
    	$('.noretinoldetail').removeClass("hide");
      	$('.retinoldetail').addClass("hide");
    }
    
    
    
    
    
    
    if (result_array.length <= 0) {
      $(".quiz-customer-product .no-data-found").removeClass("hide");
      $(".quiz-customer-product .quiz-product-block").addClass("hide");
    }
    else {
      $(".quiz-customer-product .quiz-product-block").removeClass("hide");
      $(".quiz-customer-product .no-data-found").addClass("hide");

      products = result_array[0];
      also_suggest = result_array[1];

      $(".quiz-customer-product .quiz-result-product .inner-product-block").each(function(index){
        var handle = $(this).attr("handle");
        $(this).addClass("hide");
        
        for (var product in products) {
          if(handle == products[product]) {
          	$(this).removeClass("hide");
          }
        }
      });
      
      if (also_suggest.length <= 0) {
      	$(".quiz-customer-product .quiz-also-suggest").addClass("hide");
      }
      else {
        $(".quiz-customer-product .quiz-also-suggest").removeClass("hide");
      }
        
      $(".quiz-customer-product .quiz-also-suggest .inner-product-block").each(function(index){
        var handle = $(this).attr("handle");
        $(this).addClass("hide");
        
        for (var suggest in also_suggest) {
          if(handle == also_suggest[suggest]) {
          	$(this).removeClass("hide");
          }
        }
      });
      
    }
  });
  
  //Add Result product to cart
  
  $("#shopify-section-quiz-result-product .add-routine-to-cart").on("click", function(){
    idArray = [];
    $(this).html('Please wait.... Adding to Cart');
    var resultProductWraper = $("#shopify-section-quiz-result-product .quiz-product-block .inner-product-wrapper");

    resultProductWraper.find(".inner-product-block").each(function(){
      if($(this).hasClass("hide") == false){
        tmp = $(this)[0];
        idArray.push($(tmp).data("variant-id"));
      }
    });

    ajaxMultiBuy(idArray);
  }); 
  
  
  $("#shopify-section-quiz-also-suggest .add-routine-to-cart").on("click", function(){
    idArray = [];
    $(this).html('Please wait.... Adding to Cart');
    var resultProductWraper = $("#shopify-section-quiz-also-suggest .quiz-product-block .inner-product-wrapper");

    resultProductWraper.find(".inner-product-block").each(function(){
      if($(this).hasClass("hide") == false){
        tmp = $(this)[0];
        idArray.push($(tmp).data("variant-id"));
      }
    });

    ajaxMultiBuy(idArray);
  });
  
  
  ajaxMultiBuy=function(o){
     
      if(o.length != 0 ){
        var a=o.shift();

        $.ajax({
          type:"GET",
          url:"/cart/add/?id="+a+"&quantity=1",
          dataType:"HTML", 
          success:function(){
            ajaxMultiBuy(o);
          },
          error:function(error){   
            addToCartFail();
            ajaxMultiBuy(o);
          }
        });
      }
      else {
         setTimeout(function(){
           $("#shopify-section-quiz-result-product .add-routine-to-cart").html('Add Routine To Cart');
           $("#shopify-section-quiz-also-suggest .add-routine-to-cart").html('Add Routine To Cart');
           sellify.ucd.helpers.ajaxCart.load(true);
      }, 1000);
        
        //return false;
      }
    }
    $('form')[0].reset();
});